import type { ISVGIconProps } from "@ab.uitools/ui-library/components/SVGIcons/types";
import classNames from "classnames";

export const AccountIcon = ({
  size,
  type,
  className = "",
  onClick,
  refHandler,
  id,
  dataId,
}: ISVGIconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className={classNames("svg-icon", {
        [`svg-icon__size-${size}`]: size,
        [`svg-icon__type-${type}`]: type,
        [className]: className,
      })}
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      onClick={onClick}
      ref={refHandler}
      id={id}
      data-id={dataId ? `${dataId}-svg-icon` : ""}
    >
      <g id="Icon / Library">
        <path
          id="Union"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M1.5415 6.9174C1.5415 4.83517 3.15798 3.08398 5.22809 3.08398H14.772C16.8421 3.08398 18.4586 4.83517 18.4586 6.9174V13.0842C18.4586 15.1665 16.8421 16.9177 14.772 16.9177H5.22809C3.15798 16.9177 1.5415 15.1665 1.5415 13.0842V6.9174ZM5.22809 4.58398C4.05454 4.58398 3.0415 5.59379 3.0415 6.9174V7.70911L16.9586 7.70912V6.9174C16.9586 5.59379 15.9456 4.58398 14.772 4.58398H5.22809ZM16.9586 9.20912L3.0415 9.20911V13.0842C3.0415 14.4079 4.05454 15.4177 5.22809 15.4177H14.772C15.9456 15.4177 16.9586 14.4079 16.9586 13.0842V9.20912ZM4.11121 13.4695C4.11121 13.0553 4.447 12.7195 4.86121 12.7195H8.16488C8.57909 12.7195 8.91488 13.0553 8.91488 13.4695C8.91488 13.8837 8.57909 14.2195 8.16488 14.2195H4.86121C4.447 14.2195 4.11121 13.8837 4.11121 13.4695ZM10.1418 12.7197C9.72756 12.7197 9.39177 13.0555 9.39177 13.4697C9.39177 13.8839 9.72756 14.2197 10.1418 14.2197H11.2434C11.6576 14.2197 11.9934 13.8839 11.9934 13.4697C11.9934 13.0555 11.6576 12.7197 11.2434 12.7197H10.1418Z"
          fill="#222222"
        />
      </g>
    </svg>

  );
};
